export default function GoogleMapEmbed() {
  return (
    <section className="w-full">
      <div className="w-full h-[300px] md:h-[400px] overflow-hidden">
        <iframe
          title="Servicegebied Ramen Repair Eindhoven"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39455.1!2d5.46!3d51.44!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6d91c0b40b4ef%3A0x8f5c0b6f1a5e5b5e!2sEindhoven!5e0!3m2!1snl!2snl!4v1600000000000!5m2!1snl!2snl&q=Eindhoven&t=m&z=11"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-full"
        ></iframe>
      </div>
    </section>
  );
}